import { JWTAuthProvider } from "icerockdev-admin-toolkit";
import {authRequestFn, tokenRefreshFn} from "./api";

export default (host: string) => new JWTAuthProvider({
    authRequestFn: authRequestFn(host),
    tokenRefreshFn: tokenRefreshFn(host),
});